import { useEffect, useState } from "react";
import axios from "axios";
import { PlentiCalculator } from "../components/PlentiCalculator";
import { LOGO_URL } from "../lib/constants";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicPlenti() {
  const [config, setConfig] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    axios.get(`${API}/public/plenti/config`).then((r) => setConfig(r.data)).catch(() => setError(true));
  }, []);

  return (
    <div className="min-h-screen bg-background" data-testid="public-plenti-page">
      <header className="border-b border-border bg-card">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-4 flex items-center gap-3">
          <img src={LOGO_URL} alt="Grian Solar Power" className="h-9 w-auto" />
          <span className="font-head font-bold text-lg">Plenti Finance Calculator</span>
        </div>
      </header>
      <main className="max-w-[1400px] mx-auto px-4 sm:px-6 py-6">
        {error ? <div className="text-muted-foreground">Calculator is temporarily unavailable.</div>
          : config ? <PlentiCalculator config={config} editable={false} />
          : <div className="text-muted-foreground">Loading…</div>}
      </main>
    </div>
  );
}
